import { create } from "zustand";
import type { UUID } from "@/api/types";

/**
 * Active-folder slice (papki-tenants v1).
 *
 * Mirrors the server-side session's active folder so the FE can render the
 * dropdown trigger synchronously (no flash of empty UI on mount) and so
 * components that need the active folder for query keys (MeetingsRegistry
 * et al.) read it from one place.
 *
 * Source of truth is still the server (`GET /api/folders/active`); the
 * `useActiveFolder` hook hydrates this slice from a react-query fetch on
 * first mount and pushes changes back via `POST /api/folders/active`.
 * Clearing the slice on logout mirrors `useAuthStore.clear()`.
 */
export interface ActiveFolderSlice {
  activeFolderId: UUID | null;
  setActive: (id: UUID | null) => void;
  clear: () => void;
}

export const useActiveFolderStore = create<ActiveFolderSlice>((set) => ({
  activeFolderId: null,
  setActive: (id) => set({ activeFolderId: id }),
  clear: () => set({ activeFolderId: null }),
}));
